import { useEffect, useState } from 'react';
import AddressForm from './components/AddressForm';
import ErrorBox from './components/ErrorBox';
import CodeForm from './components/CodeForm';
import SuccessCard from './components/SuccessCard';
import TopBar from './components/TopBar';
import Footer from './components/Footer';
import useApp from './hooks/useApp';

function App() {

  const [urlHash, setUrlHash] = useState('')
  const [currentYear] = useState(() => new Date().getFullYear());

  useEffect(() => {
    const urlHash = window.location.pathname.split("/").pop() || ""
    setUrlHash(urlHash)
  }, [])

  const {
    code,
    showComponent,
    showErrorBox,
    errorMessage,
    updatingAddress,
    address,
    carrier,
    trackingCode,
    brand,
    loadingCode,
    validateCode,
    setCode,
    updateAddress,
    addressString
  } = useApp(urlHash)


  return (
    <div className='bg-gray-100 min-h-screen flex flex-col justify-between'>
      {showComponent !== 1 && (
        <TopBar {...brand}></TopBar>
      )}
      <div className='p-6'>
        {showErrorBox === true && (
          <ErrorBox message={errorMessage} />
        )}
        {showComponent === 1 && (
          <CodeForm
            validateCode={validateCode}
            loading={loadingCode}
            code={code}
            setCode={setCode}
          />
        )}
        {showComponent === 2 && (
          <AddressForm
            initialValues={address}
            updateAddress={updateAddress}
            loading={updatingAddress}
            carrier={carrier}
            trackingCode={trackingCode}
            brandName={brand.brandName}
            addressString={addressString}
          />
        )}
        {showComponent === 3 && (
          <SuccessCard />
        )}
      </div>
      <Footer year={currentYear}></Footer>
    </div>
  );
}

export default App;
